import React from "react";
import Button from "@material-ui/core/Button";

export default function PrescriptionEHR(props) {
  let btnStatus = props.enabledSaveBtn;

  return (
    <div className="shadow p-3 m-2 bg-white rounded-lg col-md-12 col-sm-12 position-relative prescription-card">
      <textarea
        name="prescription-txt"
        id="prescription-txt"
        rows="10"
        placeholder="Prescription here, Sug: In each line / item of the prescription you must prepend an asterisk (*)"
        className="mb-3 w-100 h-60-custom form-control col-md-12"
        onChange={props.handleNotes}
        value={props.prescriptionValue}
      ></textarea>
      <div className="row">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            props.handleSave();
            props.handleRefreshData();
          }}
          className="col-md-6"
          // disabled={!btnStatus}
        >
          Save
        </Button>
      </div>
      <div className="col-sm-12 col-md-12 mt-1 text-center">
        <p className="font-weight-bold">{props.responseMessage}</p>
      </div>
    </div>
  );
}
